module.exports = __webpack_public_path__ + "img/捣蛋帽_礼物.1327ec8f.png";